/** Shared visual tokens for the device debug panel. */
export function buildDebugPanelTokens(c, dark, A) {
  const soft = (a) => `${A}${a}`;
  return {
    panelGap: 12,
    radius: 10,
    radiusSm: 8,
    shadow: dark ? "0 8px 24px rgba(0,0,0,.35)" : "0 4px 16px rgba(15,23,42,.08)",
    shadowSm: dark ? "none" : "0 1px 2px rgba(0,0,0,.04)",
    accentBar: `linear-gradient(90deg, ${A} 0%, ${soft("55")} 45%, transparent 100%)`,
    positive: {
      bg: dark ? "#22C55E14" : "#F0FDF4",
      border: dark ? "#22C55E40" : "#BBF7D0",
      text: dark ? "#86EFAC" : "#166534",
    },
    negative: {
      bg: dark ? "#EF444414" : "#FEF2F2",
      border: dark ? "#EF444440" : "#FECACA",
      text: dark ? "#FCA5A5" : "#B91C1C",
    },
    neutral: {
      bg: c.card,
      border: c.cardBdr,
      text: c.text,
    },
    codeBg: dark ? "#0D0F14" : "#FAFAF8",
    codeBorder: dark ? "rgba(255,255,255,.06)" : c.cardBdr,
  };
}
